<template>
	<type-wrapper class="cancel" limit>
		<type-grid row="2" margin>
			<type-image mode="widthFix" :src="image"></type-image>
		</type-grid>
		<type-grid row="2" margin>
			<type-title medium weight="normal">
				订单已取消
			</type-title>
			<type-content large center weight="normal">
				正在跳回首页 {{count}}
			</type-content>
		</type-grid>
	</type-wrapper>
</template>

<script>
	export default {
		name: 'cancel',
		data() {
			return {
				count: 3,
				timer: null,
				image: require('../../assets/image/about-img.jpg')
			}
		},
		created() {
			this.timer = setInterval(() => {
				this.count -= 1;
				if (this.count === 0) {
					clearInterval(this.timer);
					this.$router.push({
						path: '/'
					});
				}
			}, 1000);
		},
		beforeDestroy() {
			clearInterval(this.timer);
		}
	}
</script>

<style scoped lang="less">
	.cancel{
		display: flex;
		flex-wrap: wrap;
	}
</style>
